import i18n from '@/i18n/i18n'

const { t } = i18n.global

export const RETAILER_USER_ROLE = {
  OWNER: 0,
  USER: 1,
  SUPER: 2
}

export const RETAILER_USER_ROLE_MAP = {
  0: t('views.retailer.users.index.table.retailer'), // owner
  1: t('views.retailer.users.index.table.limited_authroized_user'), // user
  2: t('views.retailer.users.index.table.full_authroized_user') // super
}
